import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import { Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import moment from 'moment';
import React, { memo, useMemo } from 'react';
import theme from '../../../../../theme';
import { Dashboard, EmailBody } from '../../../../../types/files';
import ArrayUtils from '../../../../../utils/ArrayUtils';
import useStyles from "../styles";

const RecentCell: React.FC<{ dashboard: Dashboard }> = ({ dashboard }) => {
    const classes = useStyles();

    const emailItems: EmailBody[] = useMemo(() =>
        ArrayUtils.sortByDescending([...dashboard?.emailBodies
            ?.filter(emailBody => ['EMAIL', 'FULL_EMAIL', 'CALL'].includes(emailBody?.type || '')) || []], 'createdAt')
    , [dashboard?.emailBodies]);

    return (<>
        {(!emailItems?.[0] || emailItems?.length < 2) ? (
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%">
                <AddCircleOutlineIcon sx={{ width: 24, height: 24, fill: theme.colors.blue['600'] }} />
                <Stack direction="column" alignItems="flex-start" justifyContent="center">
                    <Typography className={classes.label} color={`${theme.colors.blue['700']} !important`}>
                        {'New deal'}
                    </Typography>
                    <Typography className={classnames(classes.label, classes.sublabel)}>
                        {moment(dashboard.createdAt).fromNow()}
                    </Typography>
                </Stack>
            </Stack>
        ) : (
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-start" width="100%">
                <MailOutlineRoundedIcon sx={{ width: 24, height: 24, fill: theme.colors.warning['400'] }} />
                <Stack direction="column" alignItems="flex-start" justifyContent="center">
                    <Typography className={classes.label} color={`${theme.colors.warning['500']} !important`}>
                        {'Email update'}
                    </Typography>
                    <Typography className={classnames(classes.label, classes.sublabel)}>
                        {moment(emailItems?.[0]?.createdAt).fromNow()}
                    </Typography>
                </Stack>
            </Stack>
        )}
    </>);
}

export default memo(RecentCell);
